import React, {useRef} from 'react'
import {SActionBtn, SIDRender, SLowcodeList, SMessage, STableActions, STags,} from 'shj-components'
import {config} from './config.tsx'
import {deleteSpecialCode, getBusinessDictList, getProductEnums,} from '@/services/product.ts'
import {apiData2Table} from '@/utils/data.ts'
import {Cascader, message} from 'antd'
import {useNavigate} from "react-router-dom";
import {useSetState} from "ahooks";
import {get, isArray} from "lodash-es";

import {filterSerchData} from "@/utils/common.ts";
import {httpOrgList} from "@/services/homeService.ts";
import {getMeasureRoomPage, startMeasureRoomProcess} from "@/services/crmTool.ts";
import {AddReservationCustomerModal} from '../../modal/AddReservationCustomerModal.tsx'
import {EditReservationTimeModal} from '../../modal/EditReservationTimeModal.tsx'
import {ChangeRoomAllocationStaffModal} from "../../modal/ChangeRoomAllocationStaffModal.tsx";
import {PushReportModal} from "@/pages/roomMeasurementTools/roomMeasurementManage/modal/PushReportModal.tsx";
import {
  CancelRoomAllocationModal
} from "@/pages/roomMeasurementTools/roomMeasurementManage/modal/CancelRoomAllocationModal.tsx";
import {getUserIdentityList} from "@/services/user.ts";
import {ViewMeasureReport} from "@/pages/roomMeasurementTools/roomMeasurementManage/modal/ViewMeasureReport.tsx";

export const measureTagConfig = {
  canceled: {
    label: '已取消',
    fontColor: '#a4a4a4',
    bgColor: '#ececec'
  },
  waitingMeasure: {
    label: '待量房',
    fontColor: '#119d6f',
    bgColor: '#bcebdc'
  },
  measured: {
    label: '已量房',
    fontColor: '#ee4d6e',
    bgColor: '#fadddd'
  },
  auditing: {
    label: '审核中',
    fontColor: '#e1742b',
    bgColor: '#f9e0c7'
  },
  completed: {
    label: '已完成',
    fontColor: '#7272f1',
    bgColor: '#cacaff'
  }
}

export default function RoomMeasurementManage() {
  const navigate = useNavigate()
  const listRef = useRef()
  const [state, setState] = useSetState<any>({
    record: {},
    reasonList: [],
  })
  const microAppData = window?.microApp?.getData?.()
  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      const data = handleParams(query)
      getMeasureRoomPage({
        params: {pageId: current, pageSize},
        data,
      })
          .then(res => {
            resolve(apiData2Table(res))
          })
          .catch(reject)
    })
  }

  const handleParams = (query) => {
    const values =  filterSerchData(query, ['appointmentTime', 'actualMeasureTime'])
    if(values.cancelReason && isArray(values.cancelReason)){
      values.cancelReason = values.cancelReason[values.cancelReason.length - 1]
    }
    return values
  }

  const onAdd = () => onEdit()
  const onEdit = (record?, key = 'ADD_CUSTOMER_INFO') => {
    switch (key) {
      case 'START_REVIEW':
        return SMessage.confirm({
          title: '确定要发起量房报告审核吗？',
          content: null,
          onOk: () => {
            return startMeasureRoomProcess(record.id).then(res => {
              message.success(res.message || '操作成功')
              listRef.current?.reload()
            })
          }
        })
      case 'ADD_OR_EDIT_INFO':
        navigate(`/saleOp/roomMeasurementTools/management/addOrEdit/${record.id}?customerId=${record.customerId}`)
        break;
      default:
        setState({[key]: true, record})
        break;
    }
  }

  const onCloseModal = (key = 'ADD_CUSTOMER_INFO') => {
    setState({[key]: false, record: {}})
  }

  const getStatusOptions = async () => {
    getBusinessDictList({data: {priKey: 'measure_room_cancel'}}).then(res => {
      const list = get(res, '[0].children[0].children[0].children', [])
      setState({reasonList: handleTree(list)})
    })
    const companyList = await httpOrgList()
    return Promise.resolve({ companyList})
  }

  const handleTree = (list) => {
    return list?.map(item => {
      item.priKey = item.object.priKey || item.id
      if(item.children){
        item.children = handleTree(item.children)
      }
      return item
    })
  }

  const onCompanyChange = async (value: any) => {
    if (value) {
      const users = await getUserIdentityList({queryEmployee: true, companyId: value})
      listRef?.current?.updateSearchData('users', users)
    } else {
      listRef?.current?.updateSearchData('users', [])
    }
  }

  const extensions = {
    request: {fetchList, getStatusOptions},
    events: {
      onAdd,
      onCompanyChange,
    },
    status: {
      selectedDisabled: ({selectedRowKeys}: any) => !selectedRowKeys.length,
      radioDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      IdRender(id){
        return  <SIDRender id={id} style={{color: '#333'}}/>
      },
      clueIdRender(text: any, record: any, index: any) {
        let label = text
        if (record?.sourceFlag == 'CONTENT_SHARING') {
          label += `-内`
        }
        return (
            <SIDRender
                id={label}
                onClick={() => {
                  microAppData.pushState(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${record.clueId}?templateNodeId=${text}`)
                }}
            />
        )
      },
      stateRender(text) {
        return <STags itemKey={text} style={{borderRadius: 5, padding: '5px 8px'}} config={measureTagConfig}/>
      },
      actionRender(status, record) {
        return <STableActions>
          {status === 'waitingMeasure' &&
              <SActionBtn auth={'editAppointmentInfo'} onClick={() => onEdit(record, 'CHANGE_TIME')}>修改预约时间</SActionBtn>}
          {status === 'waitingMeasure' &&
              <SActionBtn auth={'editMeasurePeople'} onClick={() => onEdit(record, 'CHANGE_STAFF')}>修改量房人</SActionBtn>}
          {status === 'waitingMeasure' &&
              <SActionBtn auth={'cancelMeasure'} onClick={() => onEdit(record, 'CANCEL')}>取消</SActionBtn>}
          {status === 'waitingMeasure' &&
              <SActionBtn auth={'enterMeasureData'} onClick={() => onEdit(record, 'ADD_OR_EDIT_INFO')}>录入量房信息</SActionBtn>}
          {status === 'measured' &&
              <SActionBtn auth={'editMeasureData'} onClick={() => onEdit(record, 'ADD_OR_EDIT_INFO')}>编辑量房信息</SActionBtn>}
          {status === 'measured' &&
              <SActionBtn auth={'measureReview'} onClick={() => onEdit(record, 'START_REVIEW')}>发起量房报告审核</SActionBtn>}
          {status === 'completed' &&
              <SActionBtn auth={'measureShare'} onClick={() => onEdit(record, 'PUSH_REPORT')}>推送量房报告</SActionBtn>}
          {(status === 'auditing' || status === 'completed') &&
              <SActionBtn auth={'measureReport'} onClick={() => onEdit(record, 'VIEW_REPORT')}>查看量房报告</SActionBtn>}
        </STableActions>
      },
      reasonRender({name, form}){
        return <Cascader placeholder={'请选择量房取消原因'}
                         showSearch expandTrigger={'hover'}
                         onChange={v => form.setFieldValue(name, v)}
                         options={state.reasonList}
                         fieldNames={{label: 'label', value: 'priKey'}}/>
      }
    },
  }

  return (
      <>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
        {/* 新增量房客户 */}
        <AddReservationCustomerModal open={state?.ADD_CUSTOMER_INFO} onClose={() => onCloseModal('ADD_CUSTOMER_INFO')}
                                     reload={listRef.current?.reload}/>
        {/* 修改预约时间 */}
        <EditReservationTimeModal open={state?.CHANGE_TIME} onClose={() => onCloseModal('CHANGE_TIME')}
                                  record={state.record} reload={listRef.current?.reload}/>
        {/* 取消 */}
        <CancelRoomAllocationModal open={state?.CANCEL} onClose={() => onCloseModal('CANCEL')} record={state.record}
                                   reload={listRef.current?.reload}/>
        {/* 修改量房人 */}
        <ChangeRoomAllocationStaffModal open={state?.CHANGE_STAFF} onClose={() => onCloseModal('CHANGE_STAFF')}
                                        record={state.record} reload={listRef.current?.reload}/>
        {/* 推送量房报告 */}
        <PushReportModal open={state?.PUSH_REPORT} onClose={() => onCloseModal('PUSH_REPORT')} record={state.record}
                         reload={listRef.current?.reload}/>
        {/* 查看量房报告 */}
        <ViewMeasureReport open={state?.VIEW_REPORT} onClose={() => onCloseModal('VIEW_REPORT')} record={state.record}/>
      </>
  )
}
